module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921125649_T.010944f7.jpg";